/* ===========================================================================
   Avaliações da loja — consome o node_avaliacoes.
   Contrato: README do node_avaliacoes. Toda resposta é { success, message, data }.

   Decisões que não são óbvias:
   - O observer só é registrado depois do `load`. Os blocos da PDP nascem dentro
     da viewport por ~2s por causa do layout shift, e um observer registrado
     antes dispara sozinho e busca tudo à toa.
   - Todo texto que vem da API passa por `esc()`. É conteúdo escrito por cliente:
     montar com innerHTML sem escapar seria XSS.
   - O lightbox é criado dentro da seção, não no body. Fora de .pha o CSS da
     seção não alcança e o visual quebra.
   - "Útil?" aparece como contador, não como botão: a API ainda não expõe
     endpoint de voto, e botão que não faz nada é pior que número parado.
   =========================================================================== */
(function () {
  'use strict';

  /* "Útil?" fica escondido enquanto a API não tiver onde receber o voto.
     Ela ENTREGA `util: {sim, nao}` em cada avaliação, mas não existe rota POST
     para registrar — os números ficariam parados em zero para sempre, com cara
     de botão que não faz nada.
     Para religar: `true` aqui, depois de criar a rota de voto no node_avaliacoes
     (e trocar os <span class="pha__util-n"> por <button>). */
  var MOSTRAR_UTIL = false;

  var ESTRELA =
    'M12 2l2.9 6.26 6.6.72-4.9 4.6 1.3 6.42L12 16.9 6.1 20l1.3-6.42L2.5 8.98l6.6-.72L12 2z';

  function svgEstrela() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + ESTRELA + '"/></svg>';
  }
  function svgCheck() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 14.3-4-4 1.4-1.4 2.6 2.6 5.6-5.6 1.4 1.4-7 7z"/></svg>';
  }
  function svgPolegar(cima) {
    return cima
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 21h3V9H2v12zM22 10c0-1.1-.9-2-2-2h-6.3l.9-4.6V3.2c0-.4-.2-.8-.4-1L13 1 6.6 7.4c-.4.4-.6.9-.6 1.4V19c0 1.1.9 2 2 2h9c.8 0 1.5-.5 1.8-1.2l3-7c.1-.3.2-.5.2-.8v-2z"/></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M22 3h-3v12h3V3zM2 14c0 1.1.9 2 2 2h6.3l-.9 4.6v.2c0 .4.2.8.4 1l1.2 1.2 6.4-6.4c.4-.4.6-.9.6-1.4V5c0-1.1-.9-2-2-2H7c-.8 0-1.5.5-1.8 1.2l-3 7c-.1.3-.2.5-.2.8v2z"/></svg>';
  }

  function esc(v) {
    if (v === null || v === undefined) return '';
    return String(v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Largura preenchida da fileira de 5 estrelas, em %.

     Não é a nota dividida por 5. Com 4,9 isso daria 98%, e os 2% que faltam
     caem na ponta fina da quinta estrela — ela parece cheia e o cliente lê
     "5 estrelas" onde está escrito 4,9.

     Então a estrela parcial fica presa entre 25% e 75% da própria largura:
     nunca parece cheia, nunca parece vazia. Nota cheia (5) continua 100%.

     A conta usa a nota crua, sem arredondar: 4,95 tem que deixar espaço na
     quinta estrela, não virar 5,0. */
  function pctEstrelas(nota) {
    var n = Math.max(0, Math.min(5, Number(nota) || 0));
    var cheias = Math.floor(n);
    var frac = n - cheias;
    if (frac > 0) frac = Math.min(0.75, Math.max(0.25, frac));
    return (cheias + frac) / 5 * 100;
  }

  /* Estrelas com preenchimento parcial: duas camadas, a de cima cortada em %. */
  function estrelas(nota, tamanho) {
    var pct = pctEstrelas(nota);
    var cinco = svgEstrela() + svgEstrela() + svgEstrela() + svgEstrela() + svgEstrela();
    return (
      '<span class="pha-stars pha-stars--' + (tamanho || 'm') + '" style="--pha-pct:' + pct.toFixed(2) + '%"' +
      ' role="img" aria-label="' + esc((Number(nota) || 0).toFixed(1)) + ' de 5">' +
      '<span class="pha-stars__camada pha-stars__bg">' + cinco + '</span>' +
      '<span class="pha-stars__camada pha-stars__fg">' + cinco + '</span>' +
      '</span>'
    );
  }

  /* "2026-04-26" -> "26/04/2026". Parse manual: new Date() numa data pura
     interpreta como UTC e no fuso -03 volta um dia. */
  function dataBR(iso) {
    if (!iso) return '';
    var p = String(iso).slice(0, 10).split('-');
    return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : esc(iso);
  }

  /* Uma casa decimal, TRUNCANDO: 4,96 vira 4,9, nunca 5,0. Arredondar
     inflaria a nota, e o cliente leria uma promessa que o produto nao tem. */
  function notaTexto(media) {
    return (Math.floor((Number(media) || 0) * 10) / 10).toFixed(1).replace(".", ",");
  }

  function num(v) {
    var n = Number(v);
    return isFinite(n) ? n : 0;
  }

  function milhar(n) {
    return String(num(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function PHAvaliacoes(raiz) {
    if (!raiz || raiz.dataset.phaPronto === '1') return;
    raiz.dataset.phaPronto = '1';

    /* No `shopify theme dev` a loja abre em 127.0.0.1:9292 e a API roda local. */
    var ehLocal = /^(127\.0\.0\.1|localhost)$/.test(location.hostname);
    var baseBruta = (ehLocal && raiz.dataset.apiDev) ? raiz.dataset.apiDev : raiz.dataset.api;

    var cfg = {
      base: (baseBruta || '').replace(/\/+$/, ''),
      loja: raiz.dataset.loja,
      produto: raiz.dataset.produto,
      porPagina: num(raiz.dataset.porPagina) || 10,
      sitekey: raiz.dataset.sitekey || '',
      produtoNome: raiz.dataset.produtoNome || '',
      produtoUrl: raiz.dataset.produtoUrl || '',
      produtoImagem: raiz.dataset.produtoImagem || ''
    };

    var el = {
      resumo: raiz.querySelector('[data-pha-resumo]'),
      filtros: raiz.querySelector('[data-pha-filtros]'),
      contexto: raiz.querySelector('[data-pha-contexto]'),
      lista: raiz.querySelector('[data-pha-lista]'),
      vazio: raiz.querySelector('[data-pha-vazio]'),
      mais: raiz.querySelector('[data-pha-mais]'),
      contagem: raiz.querySelector('[data-pha-contagem]'),
      erro: raiz.querySelector('[data-pha-erro]'),
      acoes: raiz.querySelector('[data-pha-acoes]'),
      abrirForm: raiz.querySelector('[data-pha-abrir-form]'),
      modal: raiz.querySelector('[data-pha-modal]'),
      form: raiz.querySelector('[data-pha-form]'),
      formMsg: raiz.querySelector('[data-pha-form-msg]'),
      notaEscolha: raiz.querySelector('[data-pha-nota]'),
      notaInput: raiz.querySelector('[data-pha-nota-input]')
    };

    var estado = {
      pagina: 0,
      totalPaginas: 1,
      total: 0,
      carregados: 0,
      nota: null,
      comMidia: false,
      ordem: 'recentes',
      carregando: false,
      resumo: null,
      midiasAbertas: []
    };

    /* ----------------------------------------------------------------- rede */

    function url(caminho, params) {
      var u = cfg.base + '/v1/' + encodeURIComponent(cfg.loja) + '/produtos/' +
              encodeURIComponent(cfg.produto) + caminho;
      var q = [];
      Object.keys(params || {}).forEach(function (k) {
        var v = params[k];
        if (v !== null && v !== undefined && v !== '') {
          q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
        }
      });
      return q.length ? u + '?' + q.join('&') : u;
    }

    function pegar(u) {
      return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function (j) {
        if (!j || j.success !== true) throw new Error((j && j.message) || 'Resposta inválida');
        return j.data;
      });
    }

    function mostrarErro(msg) {
      if (!el.erro) return;
      el.erro.textContent = msg;
      el.erro.hidden = false;
    }

    /* --------------------------------------------------------------- resumo */

    function pintarResumo(d) {
      estado.resumo = d;
      var total = num(d.total);
      var media = num(d.media);

      if (total === 0) {
        el.resumo.innerHTML =
          '<div class="pha__resumo-grid">' +
            '<div>' +
              '<div class="pha__nota-linha">' + estrelas(0, 'g') + '</div>' +
              '<p class="pha__total">Este produto ainda não tem avaliações.</p>' +
              '<div class="pha__slot-botao" data-pha-slot></div>' +
            '</div>' +
          '</div>';
        moverBotao();
        if (el.filtros) el.filtros.hidden = true;
        return;
      }

      var porNota = d.por_nota || {};
      var barras = '';
      for (var n = 5; n >= 1; n--) {
        var qtd = num(porNota[n] || porNota[String(n)]);
        var pct = total ? (qtd / total * 100) : 0;
        barras +=
          '<button type="button" class="pha__barra" data-pha-filtro-nota="' + n + '"' +
            ' aria-pressed="false" aria-label="Filtrar por ' + n + ' estrelas">' +
            '<span class="pha__barra-rotulo">' + n + ' ' + svgEstrela() + '</span>' +
            '<span class="pha__barra-trilho"><span class="pha__barra-fill" style="width:' + pct.toFixed(1) + '%"></span></span>' +
            '<span class="pha__barra-qtd">' + milhar(qtd) + '</span>' +
          '</button>';
      }

      var recomendam = num(d.pct_recomendam) > 0
        ? '<p class="pha__recomendam">' + svgCheck() +
          '<span><b>' + num(d.pct_recomendam).toFixed(0) + '%</b> recomendam este produto</span></p>'
        : '';

      el.resumo.innerHTML =
        '<div class="pha__resumo-grid">' +
          '<div>' +
            '<div class="pha__nota-linha">' +
              '<span class="pha__media-nota">' + notaTexto(media) + '</span>' +
              estrelas(media, 'g') +
            '</div>' +
            '<p class="pha__total"><b>' + milhar(total) + (total === 1 ? ' avaliação' : ' avaliações') +
              '</b> verificadas</p>' +
            recomendam +
            '<div class="pha__slot-botao" data-pha-slot></div>' +
          '</div>' +
          '<div class="pha__hist">' + barras + '</div>' +
        '</div>' +
        '<div class="pha__tira-bloco" data-pha-tira-bloco hidden>' +
          '<div class="pha__tira-cab">' +
            '<span class="pha__tira-titulo">Fotos e vídeos de clientes</span>' +
            '<button type="button" class="pha__link" data-pha-filtro-midia>Ver avaliações com mídia</button>' +
          '</div>' +
          '<div class="pha__tira" data-pha-tira></div>' +
        '</div>';

      moverBotao();
      pintarFiltros();
      carregarTira();
    }

    /* O botão de avaliar é escrito no Liquid (precisa do texto do setting) e
       movido para dentro do cartão do resumo. Continua dentro de .pha, então
       não perde o CSS da seção. */
    function moverBotao() {
      var slot = el.resumo.querySelector('[data-pha-slot]');
      if (slot && el.acoes) slot.appendChild(el.acoes);
    }

    /* --------------------------------------------------------------- filtros */

    function pintarFiltros() {
      if (!el.filtros || !estado.resumo) return;
      var d = estado.resumo;
      var total = num(d.total);
      var comMidia = num(d.com_foto) + num(d.com_video);
      var porNota = d.por_nota || {};

      var chips =
        '<button type="button" class="pha__chip" data-pha-limpar aria-pressed="true">' +
          'Todas <span class="pha__chip-n">' + milhar(total) + '</span></button>';

      if (comMidia > 0) {
        chips +=
          '<button type="button" class="pha__chip" data-pha-filtro-midia aria-pressed="false">' +
            'Com foto ou vídeo <span class="pha__chip-n">' + milhar(comMidia) + '</span></button>';
      }

      for (var n = 5; n >= 1; n--) {
        var qtd = num(porNota[n] || porNota[String(n)]);
        if (qtd === 0) continue;
        chips +=
          '<button type="button" class="pha__chip" data-pha-filtro-nota="' + n + '" aria-pressed="false">' +
            n + ' ' + svgEstrela() + ' <span class="pha__chip-n">' + milhar(qtd) + '</span></button>';
      }

      chips +=
        '<div class="pha__ordem">' +
          '<span class="pha__ordem-rotulo">Ordenar:</span>' +
          '<select data-pha-ordem aria-label="Ordenar avaliações">' +
            '<option value="recentes">Mais recentes</option>' +
            '<option value="uteis">Mais úteis</option>' +
            '<option value="maior_nota">Maior nota</option>' +
            '<option value="menor_nota">Menor nota</option>' +
            '<option value="com_midia">Com foto ou vídeo</option>' +
          '</select>' +
        '</div>';

      el.filtros.innerHTML = chips;
      el.filtros.hidden = false;
      sincronizarChips();
    }

    function sincronizarChips() {
      raiz.querySelectorAll('[data-pha-filtro-nota]').forEach(function (b) {
        b.setAttribute('aria-pressed', num(b.dataset.phaFiltroNota) === estado.nota ? 'true' : 'false');
      });
      raiz.querySelectorAll('[data-pha-filtro-midia]').forEach(function (b) {
        if (b.classList.contains('pha__chip')) {
          b.setAttribute('aria-pressed', estado.comMidia ? 'true' : 'false');
        }
      });
      var todas = raiz.querySelector('[data-pha-limpar]');
      if (todas) todas.setAttribute('aria-pressed', (!estado.nota && !estado.comMidia) ? 'true' : 'false');

      if (el.contexto) {
        var t = 'Exibindo avaliações de compras verificadas';
        if (estado.nota) t = 'Exibindo apenas avaliações de ' + estado.nota + ' estrela' + (estado.nota > 1 ? 's' : '');
        else if (estado.comMidia) t = 'Exibindo apenas avaliações com foto ou vídeo';
        el.contexto.textContent = t;
      }
    }

    function alternarNota(n) {
      estado.nota = estado.nota === n ? null : n;
      estado.comMidia = false;
      sincronizarChips();
      carregar(true);
    }

    raiz.addEventListener('click', function (ev) {
      var alvo = ev.target.closest('[data-pha-filtro-nota],[data-pha-filtro-midia],[data-pha-limpar]');
      if (!alvo || !raiz.contains(alvo)) return;

      if (alvo.hasAttribute('data-pha-filtro-nota')) {
        alternarNota(num(alvo.dataset.phaFiltroNota));
      } else if (alvo.hasAttribute('data-pha-filtro-midia')) {
        estado.comMidia = !estado.comMidia;
        estado.nota = null;
        sincronizarChips();
        carregar(true);
        el.lista.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        estado.nota = null;
        estado.comMidia = false;
        sincronizarChips();
        carregar(true);
      }
    });

    raiz.addEventListener('change', function (ev) {
      if (!ev.target.matches('[data-pha-ordem]')) return;
      estado.ordem = ev.target.value;
      carregar(true);
    });

    /* ----------------------------------------------- tira de fotos e vídeos */

    function carregarTira() {
      var bloco = raiz.querySelector('[data-pha-tira-bloco]');
      var tira = raiz.querySelector('[data-pha-tira]');
      if (!bloco || !tira) return;

      pegar(url('/avaliacoes', { pagina: 1, por_pagina: 10, ordem: 'com_midia', com_midia: 1 }))
        .then(function (d) {
          var todas = [];
          (d.itens || []).forEach(function (a) {
            (a.midias || []).forEach(function (m) { todas.push(m); });
          });
          if (!todas.length) return;

          tira.__midias = todas;
          tira.innerHTML = todas.slice(0, 8).map(function (m, i) {
            return miniatura(m, i);
          }).join('');
          bloco.hidden = false;
        })
        .catch(function () { /* a tira é enfeite: falhar aqui não quebra a lista */ });
    }

    /* ------------------------------------------------------------ avaliação */

    /* `rotacao` vem da moderação (0/90/180/270): o arquivo no R2 não é girado,
       quem gira é o tema. */
    function miniatura(m, i) {
      var video = m.tipo === 'video';
      var rot = num(m.rotacao);
      var thumb = m.thumb || (video ? '' : m.url);
      var img = thumb
        ? '<img src="' + esc(thumb) + '" alt="" loading="lazy" width="78" height="78"' +
          (rot ? ' style="--pha-rot:' + rot + 'deg"' : '') + '>'
        : '';
      return '<button type="button" class="pha__midia' + (video ? ' pha__midia--video' : '') + '"' +
             ' data-pha-midia="' + i + '" aria-label="' + (video ? 'Abrir vídeo' : 'Abrir foto') + '">' +
             img + '</button>';
    }

    function midiasHtml(midias) {
      if (!midias || !midias.length) return '';
      return '<div class="pha__midias" data-pha-galeria>' +
        midias.map(function (m, i) { return miniatura(m, i); }).join('') + '</div>';
    }

    function itemHtml(a) {
      var inicial = (String(a.autor || '?').trim().charAt(0) || '?').toUpperCase();
      var selo = a.compra_verificada
        ? '<span class="pha__selo">' + svgCheck() + 'Compra verificada</span>' : '';
      var titulo = a.titulo ? '<div class="pha__item-titulo">' + esc(a.titulo) + '</div>' : '';
      var comentario = a.comentario ? '<div class="pha__comentario">' + esc(a.comentario) + '</div>' : '';
      var variante = a.variante ? '<div class="pha__recomenda">Variação: ' + esc(a.variante) + '</div>' : '';
      var util = a.util || {};
      var resposta = a.resposta
        ? '<div class="pha__resposta"><span class="pha__resposta-por">Resposta da loja</span>' +
          esc(a.resposta.texto) + '</div>'
        : '';

      return (
        '<li class="pha__item" data-pha-item>' +
          '<div class="pha__item-topo">' +
            '<span class="pha__avatar" aria-hidden="true">' + esc(inicial) + '</span>' +
            '<div>' +
              '<div class="pha__ident-linha">' +
                '<span class="pha__autor">' + esc(a.autor) + '</span>' + selo +
              '</div>' +
              '<div class="pha__sub-linha">' +
                estrelas(num(a.nota), 'p') +
                '<span class="pha__data">' + dataBR(a.data) + '</span>' +
              '</div>' +
            '</div>' +
            (MOSTRAR_UTIL
              ? '<div class="pha__util">' +
                  '<span class="pha__util-rotulo">Útil?</span>' +
                  '<span class="pha__util-n">' + svgPolegar(true) + num(util.sim) + '</span>' +
                  '<span class="pha__util-n">' + svgPolegar(false) + num(util.nao) + '</span>' +
                '</div>'
              : '') +
          '</div>' +
          titulo + comentario + variante +
          midiasHtml(a.midias) +
          resposta +
        '</li>'
      );
    }

    function carregar(reiniciar) {
      if (estado.carregando) return;
      if (reiniciar) {
        estado.pagina = 0;
        estado.totalPaginas = 1;
        estado.carregados = 0;
        el.lista.innerHTML = '';
      }
      if (estado.pagina >= estado.totalPaginas) return;

      estado.carregando = true;
      if (el.mais) el.mais.disabled = true;

      var proxima = estado.pagina + 1;
      pegar(url('/avaliacoes', {
        pagina: proxima,
        por_pagina: cfg.porPagina,
        nota: estado.nota || '',
        com_midia: estado.comMidia ? 1 : '',
        ordem: estado.ordem
      })).then(function (d) {
        var itens = (d && d.itens) || [];
        var pag = (d && d.paginacao) || {};

        estado.pagina = num(pag.pagina) || proxima;
        estado.totalPaginas = num(pag.total_paginas) || 1;
        estado.total = num(pag.total);
        estado.carregados += itens.length;

        /* guarda as mídias de cada item para o lightbox saber o que abrir */
        var base = el.lista.children.length;
        el.lista.insertAdjacentHTML('beforeend', itens.map(itemHtml).join(''));
        itens.forEach(function (a, i) {
          var li = el.lista.children[base + i];
          if (li) li.__midias = a.midias || [];
        });

        if (el.vazio) el.vazio.hidden = !(estado.pagina === 1 && itens.length === 0);
        if (el.mais) el.mais.hidden = estado.pagina >= estado.totalPaginas;
        if (el.contagem) {
          el.contagem.textContent = estado.total
            ? 'Mostrando ' + milhar(estado.carregados) + ' de ' + milhar(estado.total)
            : '';
        }
      }).catch(function (e) {
        mostrarErro('Não foi possível carregar as avaliações agora. ' + e.message);
      }).then(function () {
        estado.carregando = false;
        if (el.mais) el.mais.disabled = false;
      });
    }

    if (el.mais) el.mais.addEventListener('click', function () { carregar(false); });

    /* ------------------------------------------------------------- lightbox */

    var lb = null;

    function abrirLightbox(midias, indice) {
      if (!midias || !midias.length) return;
      estado.midiasAbertas = midias;

      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'pha__lb';
        lb.innerHTML =
          '<button type="button" class="pha__lb-fechar" aria-label="Fechar">&times;</button>' +
          '<button type="button" class="pha__lb-nav pha__lb-nav--ant" aria-label="Anterior">&#8249;</button>' +
          '<div data-pha-lb-conteudo></div>' +
          '<button type="button" class="pha__lb-nav pha__lb-nav--prox" aria-label="Próxima">&#8250;</button>';
        /* dentro da seção de propósito: no body o CSS da seção não alcança */
        raiz.appendChild(lb);

        lb.addEventListener('click', function (ev) {
          if (ev.target === lb || ev.target.closest('.pha__lb-fechar')) return fecharLightbox();
          if (ev.target.closest('.pha__lb-nav--ant')) return passar(-1);
          if (ev.target.closest('.pha__lb-nav--prox')) return passar(1);
        });
        document.addEventListener('keydown', function (ev) {
          if (!lb || lb.hidden) return;
          if (ev.key === 'Escape') fecharLightbox();
          if (ev.key === 'ArrowLeft') passar(-1);
          if (ev.key === 'ArrowRight') passar(1);
        });
      }

      lb.hidden = false;
      lb.dataset.i = indice;
      pintarLightbox();
    }

    function pintarLightbox() {
      var i = num(lb.dataset.i);
      var m = estado.midiasAbertas[i];
      if (!m) return;
      var rot = num(m.rotacao);
      var estilo = rot ? ' style="--pha-rot:' + rot + 'deg"' : '';
      /* em 90/270 os limites de largura e altura trocam de eixo */
      lb.classList.toggle('pha__lb--girada', rot === 90 || rot === 270);

      var alvo = lb.querySelector('[data-pha-lb-conteudo]');
      alvo.innerHTML = m.tipo === 'video'
        ? '<video class="pha__lb-midia" src="' + esc(m.url) + '" controls autoplay playsinline' + estilo + '></video>'
        : '<img class="pha__lb-midia" src="' + esc(m.url) + '" alt=""' + estilo + '>';

      var varias = estado.midiasAbertas.length > 1;
      lb.querySelector('.pha__lb-nav--ant').hidden = !varias;
      lb.querySelector('.pha__lb-nav--prox').hidden = !varias;
    }

    function passar(d) {
      var total = estado.midiasAbertas.length;
      lb.dataset.i = (num(lb.dataset.i) + d + total) % total;
      pintarLightbox();
    }

    function fecharLightbox() {
      if (!lb) return;
      lb.querySelector('[data-pha-lb-conteudo]').innerHTML = '';
      lb.hidden = true;
    }

    el.lista.addEventListener('click', function (ev) {
      var botao = ev.target.closest('[data-pha-midia]');
      if (!botao) return;
      var li = botao.closest('[data-pha-item]');
      abrirLightbox((li && li.__midias) || [], num(botao.dataset.phaMidia));
    });

    raiz.addEventListener('click', function (ev) {
      var botao = ev.target.closest('[data-pha-tira] [data-pha-midia]');
      if (!botao) return;
      var tira = botao.closest('[data-pha-tira]');
      abrirLightbox((tira && tira.__midias) || [], num(botao.dataset.phaMidia));
    });

    /* ----------------------------------------------------------- formulário */

    var turnstilePedido = false;
    function carregarTurnstile() {
      if (turnstilePedido || !cfg.sitekey) return;
      turnstilePedido = true;
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      s.async = true;
      s.defer = true;
      document.head.appendChild(s);
    }

    function abrirModal() {
      if (!el.modal) return;
      el.modal.hidden = false;
      document.body.classList.add('pha-modal-aberto');
      el.abrirForm.setAttribute('aria-expanded', 'true');
      carregarTurnstile();
      var primeiro = el.modal.querySelector('input, textarea, button');
      if (primeiro) setTimeout(function () { primeiro.focus(); }, 30);
    }

    function fecharModal() {
      if (!el.modal) return;
      el.modal.hidden = true;
      document.body.classList.remove('pha-modal-aberto');
      el.abrirForm.setAttribute('aria-expanded', 'false');
      el.abrirForm.focus();
    }

    if (el.abrirForm && el.modal) {
      el.abrirForm.addEventListener('click', abrirModal);
      el.modal.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-pha-fechar-modal]')) fecharModal();
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !el.modal.hidden) fecharModal();
      });
    }

    if (el.notaEscolha) {
      el.notaEscolha.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-pha-nota-valor]');
        if (!b) return;
        var v = num(b.dataset.phaNotaValor);
        el.notaInput.value = v;
        el.notaEscolha.querySelectorAll('[data-pha-nota-valor]').forEach(function (x) {
          x.dataset.on = num(x.dataset.phaNotaValor) <= v ? '1' : '0';
        });
      });
    }

    function msgForm(texto, ok) {
      if (!el.formMsg) return;
      el.formMsg.textContent = texto;
      el.formMsg.className = 'pha__msg ' + (ok ? 'pha__msg--ok' : 'pha__msg--erro');
    }

    /* ------------------------------------------------- escolha de arquivos */

    /* O input de arquivo não deixa remover um item da seleção: `files` é só
       leitura. Então guardamos a lista aqui e reconstruímos o `files` com um
       DataTransfer toda vez que muda — é o que permite o "x" em cada foto. */
    var campoMidias = raiz.querySelector('[data-pha-midias]');
    var listaArquivos = raiz.querySelector('[data-pha-arquivos]');
    var escolhidos = [];

    function ehVideo(f) { return /^video\//.test(f.type); }

    function limiteEstourado(lista) {
      var fotos = lista.filter(function (f) { return !ehVideo(f); });
      var videos = lista.filter(ehVideo);
      if (fotos.length > 5) return 'Envie no máximo 5 fotos.';
      if (videos.length > 1) return 'Envie no máximo 1 vídeo.';
      for (var i = 0; i < lista.length; i++) {
        var f = lista[i];
        if (ehVideo(f) && f.size > 50 * 1024 * 1024) return 'Cada vídeo precisa ter até 50 MB.';
        if (!ehVideo(f) && f.size > 10 * 1024 * 1024) return 'Cada foto precisa ter até 10 MB.';
      }
      return '';
    }

    function sincronizarInput() {
      try {
        var dt = new DataTransfer();
        escolhidos.forEach(function (f) { dt.items.add(f); });
        campoMidias.files = dt.files;
      } catch (e) {
        /* navegador sem DataTransfer: deixa a seleção original do input valer */
      }
    }

    function pintarArquivos() {
      if (!listaArquivos) return;
      listaArquivos.innerHTML = escolhidos.map(function (f, i) {
        var thumb = ehVideo(f)
          ? '<span class="pha__arquivo-video" aria-hidden="true"></span>'
          : '<img src="' + URL.createObjectURL(f) + '" alt="">';
        return '<span class="pha__arquivo-item">' + thumb +
          '<button type="button" class="pha__arquivo-x" data-pha-remover="' + i + '"' +
          ' aria-label="Remover ' + esc(f.name) + '">&times;</button></span>';
      }).join('');
    }

    if (campoMidias) {
      campoMidias.addEventListener('change', function () {
        var novos = Array.prototype.slice.call(campoMidias.files || []);

        /* O mesmo arquivo não entra duas vezes. Sem isto, um `change` disparado
           em duplicidade (ou o cliente escolhendo a mesma foto de novo) somaria
           a seleção inteira outra vez. */
        var assinatura = function (f) { return f.name + '|' + f.size + '|' + f.lastModified; };
        var jaTem = {};
        escolhidos.forEach(function (f) { jaTem[assinatura(f)] = 1; });
        novos = novos.filter(function (f) {
          var a = assinatura(f);
          if (jaTem[a]) return false;
          jaTem[a] = 1;
          return true;
        });

        var tentativa = escolhidos.concat(novos);
        var erro = limiteEstourado(tentativa);
        if (erro) { sincronizarInput(); return msgForm(erro, false); }
        escolhidos = tentativa;
        sincronizarInput();
        pintarArquivos();
        msgForm('', true);
      });
    }

    if (listaArquivos) {
      listaArquivos.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-pha-remover]');
        if (!b) return;
        escolhidos.splice(num(b.dataset.phaRemover), 1);
        sincronizarInput();
        pintarArquivos();
      });
    }

    if (el.form) {
      el.form.addEventListener('submit', function (ev) {
        ev.preventDefault();

        if (!num(el.notaInput && el.notaInput.value)) {
          return msgForm('Escolha de 1 a 5 estrelas antes de enviar.', false);
        }

        /* limites do contrato: 5 fotos (10 MB) + 1 vídeo (50 MB).
           Já foram checados na escolha; aqui é a rede de segurança. */
        var erroArquivo = limiteEstourado(escolhidos);
        if (erroArquivo) return msgForm(erroArquivo, false);

        var dados = new FormData(el.form);
        if (cfg.produtoNome) dados.set('produto_nome', cfg.produtoNome);
        if (cfg.produtoUrl) dados.set('produto_url', cfg.produtoUrl);
        if (cfg.produtoImagem) dados.set('produto_imagem', cfg.produtoImagem);

        var botao = el.form.querySelector('[type="submit"]');
        if (botao) botao.disabled = true;
        msgForm('Enviando…', true);

        fetch(url('/avaliacoes'), { method: 'POST', body: dados })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (j && j.success) {
              msgForm(j.message || 'Avaliação recebida. Ela aparece aqui depois de aprovada.', true);
              el.form.reset();
              if (el.notaInput) el.notaInput.value = '';
              if (el.notaEscolha) {
                el.notaEscolha.querySelectorAll('[data-pha-nota-valor]')
                  .forEach(function (x) { x.dataset.on = '0'; });
              }
              escolhidos = [];
              sincronizarInput();
              pintarArquivos();
            } else {
              msgForm((j && j.message) || 'Não foi possível enviar sua avaliação.', false);
            }
            /* sem reset o segundo envio reusaria o token e seria recusado */
            if (window.turnstile) { try { window.turnstile.reset(); } catch (e) {} }
          })
          .catch(function () {
            msgForm('Não foi possível enviar agora. Tente de novo em instantes.', false);
          })
          .then(function () { if (botao) botao.disabled = false; });
      });
    }

    /* ---------------------------------------------------------- disparo */

    /* O resumo é um JSON minúsculo e alimenta também a nota do topo da página,
       que fica acima da dobra. Por isso ele NÃO espera o observer — só a lista,
       que é o que pesa, continua preguiçosa. */
    function carregarResumo() {
      return pegar(url('/resumo'))
        .then(function (d) {
          pintarResumo(d);
          espelharNoTopo(d);
        })
        .catch(function (e) {
          mostrarErro('Não foi possível carregar o resumo das avaliações. ' + e.message);
        });
    }

    /* A nota do topo é renderizada pelo Liquid a partir do metacampo (é o que o
       Google lê e o que aparece sem JS). Enquanto o sync de metacampos estiver
       desligado, esse número fica atrás do nosso — então sobrescrevemos. */
    function espelharNoTopo(d) {
      var alvo = document.querySelector('[data-pha-espelho]');
      if (!alvo || !num(d.total)) return;

      var media = num(d.media);
      var txt = notaTexto(media);

      var estrelasEl = alvo.querySelector('.phe__stars');
      var notaEl = alvo.querySelector('.phe__nota');
      var linkEl = alvo.querySelector('a');

      if (estrelasEl) estrelasEl.style.setProperty('--phe-pct', pctEstrelas(media).toFixed(2) + '%');
      if (notaEl) notaEl.textContent = txt;
      if (linkEl) linkEl.textContent = milhar(num(d.total)) + ' avaliações';
    }

    function iniciar() {
      carregar(true);
    }

    /* Observer só depois do load: antes disso o bloco nasce dentro da viewport
       por causa do layout shift e o observer dispararia sozinho. */
    function armar() {
      if (!('IntersectionObserver' in window)) return iniciar();
      var io = new IntersectionObserver(function (entradas) {
        if (entradas.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          iniciar();
        }
      }, { rootMargin: '400px 0px' });
      io.observe(raiz);
    }

    carregarResumo();

    if (document.readyState === 'complete') armar();
    else window.addEventListener('load', armar, { once: true });
  }

  function varrer(escopo) {
    (escopo || document).querySelectorAll('[data-pha]').forEach(PHAvaliacoes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { varrer(); });
  } else {
    varrer();
  }

  /* editor de temas: a seção é re-renderizada e precisa ser religada */
  document.addEventListener('shopify:section:load', function (ev) { varrer(ev.target); });
})();
